import { render } from "./AddFunds.vue?vue&type=template&id=6ec72fe9"
import script from "./AddFunds.vue?vue&type=script&lang=js"
export * from "./AddFunds.vue?vue&type=script&lang=js"

import "./AddFunds.vue?vue&type=style&index=0&id=6ec72fe9&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__